import React from 'react';

import { CardDomain } from './components/CardDomain/CardDomain';
import { Container } from './CategoryCard.styles';

interface CategoryCardProps {
	category: any;
}

export const CategoryCard = ({ category }: CategoryCardProps) => {
	return (
		<Container>
			<CardDomain category={category} />
		</Container>
	);
};
